import React from "react";
import Navbar from "../resuables/navbar";
import Footer from "../resuables/footer";
import QuickContact from "../resuables/quick-contact";
import { useEffect } from "react";
import AcademicPic from "../resources/images/academics.jpg";

function Academics() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main">
      {/* <QuickContact /> */}
      <Navbar />
      <div className="content">
        <div className="content-header-container">
          <div className="bg-pattern"></div>

          <h2 className="content-name">What and How we Learn</h2>
        </div>
        <br />
        <div className="content-page-img">
          <img src={AcademicPic} alt="" />
        </div>

        <div className="content-body admission-process">
          <p>
            We are committed to providing a well-rounded education that nurtures
            the academic social and emotional development of every child. OUR
            curriculum is desinged to meet the needs of a diverse student body,
            ensuring that each child is prepared for future academic success,
            lifelong learning and goals.
          </p>
          <br />
          <br />
          <h2 className="content-name info-section-header">Our Curriculum</h2>
          <p>
            Our curriculum is designed in alignment with the Ghana Education
            Service (GES) and the National Council for Curriculum and Assessment
            (NaCCA) standards, ensuring that we deliver a comprehensive and
            nationally recognized education. By following the GES guidelines,
            our curriculum emphasizes core competencies, practical skills, and
            character development. Our goal is to cultivate critical thinkers,
            responsible citizens, and lifelong learners who are well-equipped to
            navigate the challenges of the modern world.
          </p>{" "}
          <br />
          <div className="curriculum-highlights">
            <h3>Highlights</h3>
            <p>
              Our curriculum is carefully crafted to meet both national
              standards and the unique needs of our students. It includes a
              range of subjects designed to encourage balanced growth in the
              following areas and with respect to wards level of education:
            </p>
            <br />
            <ul>
              <li>
                <strong>Core Subjects:</strong> Emphasis on Math, Science,
                Language Arts, and Social Studies, building a strong foundation
                for future academic success.
              </li>
              <li>
                <strong>Creative Arts:</strong> Opportunities for students to
                express themselves through Art, Music, and Drama, fostering
                creativity and self-confidence.
              </li>
              <li>
                <strong>Physical Education:</strong> Encouraging physical
                activity and healthy lifestyles, Physical Education classes help
                students understand the importance of wellness and teamwork.
              </li>
              <li>
                <strong>Technology Integration:</strong> Introduction to digital
                literacy and basic computing skills, preparing students to
                engage with modern technology responsibly and effectively.
              </li>
            </ul>
          </div>
          <br />
          <br />
          <div className="curriculum-diag">
            {/* <select name="" id="">
              <option value="">PreSchool</option>
              <option value="">Kindergarten</option>
              <option value="">Lower Primary</option>
              <option value="">Upper Primary</option>
              <option value="">Junior High School</option>
            </select> */}
            <div className="details">
              <div className="subject core">Numeracy</div>
              <div className="subject extra">Cadet</div>

              <div className="subject core">Literacy</div>
              <div className="subject general">OWOP</div>
              <div className="subject general">Creative Arts</div>
              <div className="subject extra">Drama and Performing Arts</div>
              <div className="subject general">Physical Education</div>
              <div className="subject core">ICT</div>
              <div className="subject language">French</div>
              <div className="subject language">Gh Language - Asante Twi</div>
              <div className="subject extra">Music & Dance</div>
              <div className="subject core">Natural Science</div>
              <div className="subject extra">Debate Club</div>
              <div className="subject extra">Programming & Robotics</div>
              <div className="subject general">History</div>
            </div>
            <div className="subject-key">
              <div className="key">
                <span style={{ backgroundColor: "" }}></span>
                Core Subjects
              </div>

              <div className="key">
                <span style={{ backgroundColor: "green" }}></span>
                Languages
              </div>
              <div className="key">
                <span style={{ backgroundColor: "palevioletred" }}></span>
                General Subjects
              </div>
              {/* <div className="key">
                <span style={{ backgroundColor: "violet" }}></span>
                Student Club
              </div> */}
              <div className="key">
                <span style={{ backgroundColor: "#f47c2c" }}></span>
                Student Club
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Academics;
